import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SlideDeck } from './components/SlideDeck';
import { SignInPage } from './pages/SignInPage';
import { ThemeProvider, ThemeType } from './context/ThemeContext';
export function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [themeType, setThemeType] = useState<ThemeType>('ajman');
  const handleSignIn = (email: string) => {
    if (email === 'sharjah@police.ae') {
      setThemeType('sharjah');
    } else if (email === 'bahrain@pair2.ae') {
      setThemeType('bahrain');
    } else if (email === 'bahrain2@pair2.ae') {
      setThemeType('bahrain2');
    } else if (email === 'dubai@police.ae') {
      setThemeType('dubai');
    } else {
      setThemeType('ajman');
    }
    setAuthenticated(true);
  };
  return <div className="relative w-screen h-screen overflow-hidden" style={{
    background: '#EDF1F4'
  }} data-id="element-0">
      <AnimatePresence mode="popLayout" data-id="element-1">
        {!authenticated ? <motion.div key="signin" initial={{
        opacity: 1
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.5,
        ease: [0.4, 0, 0.2, 1]
      }} className="absolute inset-0" data-id="element-2">
            <SignInPage onSignIn={handleSignIn} data-id="element-3" />
          </motion.div> : <motion.div key="deck" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.7,
        ease: [0.4, 0, 0.2, 1]
      }} className="absolute inset-0" data-id="element-4">
            <ThemeProvider themeType={themeType} data-id="element-5">
              <SlideDeck data-id="element-6" />
            </ThemeProvider>
          </motion.div>}
      </AnimatePresence>
    </div>;
}